// Shared result grid for the labs tabs. Click = seed ("more like this");
// shift-click = add to the multi-seed tray (Search tab). Distances overlaid;
// in seed mode anything under dupeThreshold gets a near-duplicate badge.
import { IMG_ROOT } from "../../lib/constants";

export interface Item {
  id: number;
  title: string;
  lowResPath: string;
  dist: number;
}

interface GridProps {
  items: Item[];
  onCell: (item: Item, shift: boolean) => void;
  dupeThreshold?: number | undefined;
}

export function Grid({ items, onCell, dupeThreshold }: GridProps) {
  return (
    <div class="ls-grid">
      {items.map((it) => (
        <div
          key={it.id}
          class="ls-cell"
          title={`${it.title} (${it.dist.toFixed(3)}) — click: more like this, shift-click: add to tray`}
          onClick={(e) => onCell(it, e.shiftKey)}
        >
          <img loading="lazy" src={`${IMG_ROOT}${it.lowResPath}`} alt={it.title} />
          <span class="ls-dist">{it.dist.toFixed(3)}</span>
          {dupeThreshold !== undefined && it.dist < dupeThreshold && (
            <span class="ls-dupe">near-dupe</span>
          )}
        </div>
      ))}
    </div>
  );
}
